export const galleryConstants = {
  GALLERY_INIT: '[Gallery] init',
  GALLERY_UPDATE: '[Gallery] Update',
  GALLERY_REMOVE: '[Gallery] Remove'
}
